import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgSelectModule } from '@ng-select/ng-select';

import { HeaderComponent } from './components/header/header.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { UserHeaderComponent } from './components/user-header/user-header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { CircleChartComponent } from './components/circle-chart/circle-chart.component';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { environment } from 'src/environments/environment';
import { ChileanMoneyDirective } from './directives/chilean-money.directive';
import { SafePipe } from './components/pipes/safe.pipe';
import { Ng9RutModule } from 'ng9-rut';
import { InputRutDirective } from './directives/input-rut.directive';
import { InputNumberDirective } from './directives/input-number.directive';
import { AgmCoreModule } from '@agm/core';
import { InputNumberFormatDirective } from './directives/input-number-format.directive';
import { InputDecimalFormatDirective } from './directives/input-decimal-format.directive';
import { UploadFilesComponent } from './components/upload-files/upload-files.component';
import { LoaderFullComponent } from './components/loader-full/loader-full.component';

@NgModule({
  declarations: [
    HeaderComponent,
    NavbarComponent,
    UserHeaderComponent,
    FooterComponent,
    CircleChartComponent,
    ChileanMoneyDirective,
    SafePipe,
    InputNumberDirective,
    InputRutDirective,
    InputNumberFormatDirective,
    InputDecimalFormatDirective,
    UploadFilesComponent,
    LoaderFullComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    NgSelectModule,
    RouterModule,
    Ng9RutModule,
    AgmCoreModule,
    NgxGoogleAnalyticsModule.forRoot(environment.googleAnalyticsId)
  ],
  providers: [CurrencyPipe],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    HeaderComponent,
    NavbarComponent,
    UserHeaderComponent,
    FooterComponent,
    CircleChartComponent,
    BsDropdownModule,
    CollapseModule,
    NgSelectModule,
    NgxGoogleAnalyticsModule,
    ChileanMoneyDirective,
    SafePipe,
    Ng9RutModule,
    InputNumberDirective,
    InputRutDirective,
    InputNumberFormatDirective,
    InputDecimalFormatDirective,
    AgmCoreModule,
    UploadFilesComponent,
    LoaderFullComponent
  ]
})
export class SharedModule { }
